import axios from 'axios'
import {ResponseObject} from '../../../models'
import {Resend2FAPayload, UserModel, Verify2FAPayload, Verify2FAResponse} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL

export function login(email: string, password: string, tokenGates: string = '') {
  return axios.post<ResponseObject<UserModel>>(`${BASEURL}/Identity`, {
    user: email,
    password,
    tokenGates,
  })
}

export function forgot(email: string) {
  return axios.get<ResponseObject<UserModel>>(`${BASEURL}/identity/forgotPassword?email=${email}`)
}

export function changePassword(token: string, newPassword: string, checkNewPassword: string) {
  return axios.post<ResponseObject<UserModel>>(`${BASEURL}/identity/updatePassword`, {
    token,
    newPassword,
    checkNewPassword,
  })
}

export function getIsOnline() {
  return axios.get<any>(`${BASEURL}/identity/isonlineactive`)
}

export function verify2FA(payload: Verify2FAPayload) {
  return axios.post<ResponseObject<Verify2FAResponse>>(
    `${BASEURL}/identity/validateToken2Factor`,
    payload,
  )
}

export function resend2FA(payload: Resend2FAPayload) {
  return axios.post<ResponseObject<any>>(`${BASEURL}/identity/resendToken2Factor`, payload)
}
